<template>
  <div>
    <div
      v-for="type in types"
      :key="type.key"
    >
      <template v-if="type.is_badge_filter">
        <div
          v-for="(attributeValue, index) in type.type_data_parsed"
          :key="index"
          class="badge-button"
        >
          <el-button @click="toggleFilter(attributeValue, type)">
            {{ attributeValue.name }} ({{ badgeCounts[attributeValue.value] || "0" }})
          </el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { mapState } from 'vuex';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import ApiService from '@fps/vue-toolkit/dist/services/api.service';
import mutations from '../store/filters/filters.mutationlist';

export default {
  props: {
    types: {
      type: Array,
      default: () => ([]),
    },
  },
  active: false,
  data() {
    return {
      badgeCounts: {},
    };
  },
  computed: {
    ...mapState({
      dynamicFilters: state => state.filters.dynamic,
      category: state => state.filters.category,
      subcategory: state => state.filters.subcategory,
    }),
  },
  watch: {
    types() {
      this.fetchCountsForFilters();
    },
  },
  created() {
    this.fetchCountsForFilters();
  },
  methods: {
    toggleFilter(filterValue, filterType) {
      this.$store.commit(mutations.FILTER_SET, {
        key: 'dynamic',
        value: {
          ...this.dynamicFilters,
          [`_${filterType.id}`]: {
            type: filterType,
            value: filterValue,
          },
        },
      });
    },
    fetchCountsForFilters() {
      // Fetch withCount for current attribute value
      const subcategory_id = dataGet('subcategory.id', this);
      const atTypes = this.types
        .filter(type => type.is_badge_filter)
        .map(type => type.id);
      if (subcategory_id && atTypes && atTypes.length) {
        ApiService.getData('ads/attribute/counts', {
          params: {
            subcategory_id,
            atTypes,
          },
        })
          .then((response) => {
            if (response && response.data && response.data.length) {
              this.badgeCounts = response.data.reduce((acc, item) => (
                { ...acc, [item.attribute]: item.badgeCount }
              ), {});
            } else {
              this.badgeCounts = {};
            }
          });
      } else {
        this.badgeCounts = {};
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BadgeButton.vue